// Keka spells centres its own way ("HRBR Layout"); Preschool Quality & Ops
// hands over Alfred's centre name, so match on letters only, then on one
// name holding the other.
const squash = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '')
export const kekaCentreFor = (name, centres) => {
  const want = squash(name)
  if (!want) return null
  return (
    centres.find((c) => squash(c) === want) ||
    centres.find((c) => {
      const have = squash(c)
      return have.length >= 4 && (want.includes(have) || have.includes(want))
    }) ||
    null
  )
}
